import { render, staticRenderFns } from "./ShareOptionsPanel.vue?vue&type=template&id=04104d5c&scoped=true&"
import script from "./ShareOptionsPanel.vue?vue&type=script&lang=js&"
export * from "./ShareOptionsPanel.vue?vue&type=script&lang=js&"
import style0 from "./ShareOptionsPanel.vue?vue&type=style&index=0&id=04104d5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04104d5c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSlideXTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VIcon,VSlideXTransition})
